import React, { useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, } from 'react-redux'
import { Input, } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { createCanteenStaff, updateCanteenStaff, } from '../../../actions/directoryCanteen'
import Modal from 'react-responsive-modal'

const validationSchema = Yup.object({
  post: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
})


export default function ModalComponent({ data, closeModal, createInteg }) {

  const dispatch = useDispatch()

  const [image, setImage] = useState(null);
  const [intName, setIntName] = useState('')

  const addMode = !data.name

  const handleCreate = async (values) => {
    // dispatch(createCanteenStaff(values, image))
    closeModal()
  }

  const handleUpdate = async ({ id, ...values }) => {
    // dispatch(updateCanteenStaff(id, values, image))
    closeModal()
  }

  const handleChange = (e) => {
    setIntName(e.target.value)
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} style={{ display: "flex", justifyContent: 'space-evenly', flexDirection: 'column' }}>
            <div className={styles.inputsRow}>
              <Input
                label='Укажите название'
                name='name'
                value={intName}
                // error={error('name')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />

            </div>
            <br />
            {!!image &&
              <img
                src={URL.createObjectURL(image)}
                alt="0_o"
                height={350}
                width={450}
              />
            }
          </div>
        </div>

        <ModalFooter handleSubmit={() => createInteg(intName)} closeModal={closeModal} />
      </>
    </Modal >
  )
}
